import components from "./components";
import componentsGroup from "./components/componentsGroup";
import type { App } from "vue"
import { CensorDialog } from "./components/CensorDialog/index";
import {watermarkDirective} from "./directives/watermark";
const install = (app: App) => {
    Object.keys(componentsGroup).forEach((componentName:any) => {
        app.component(componentName, componentsGroup[componentName])
    })
    Object.values(components).forEach((component:any) => {
        app.component(component.name!, component)
    })
    app.directive('watermark', watermarkDirective)
}

export default {
    install
}
export {
   CensorDialog
}